import { Outlet } from 'react-router';

import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import { SearchLayoutRoot } from '@sorare/core/src/components/search/SearchLayout/ui';
import { navLabels } from '@sorare/core/src/lib/glossary';

export const MyCardsVaultLayout = () => {
  return (
    <SearchLayoutRoot>
      <PageHeader text={navLabels.vault} disableBackBrowser />
      <Outlet />
    </SearchLayoutRoot>
  );
};
